import { useTranslation } from "react-i18next";

import { useAppStore } from "../lib/store";
import { getThemeColors } from "../lib/theme";

interface ProfileAvatarProps {
  image: string | null | undefined;
  name: string;
  size?: "sm" | "md";
}

export function ProfileAvatar({
  image,
  name,
  size = "md",
}: ProfileAvatarProps) {
  const isDark = useAppStore((state) => state.isDark);
  const theme = getThemeColors(isDark);
  const { t } = useTranslation();
  const sizeClass = size === "sm" ? "h-6 w-6 text-xs" : "h-12 w-12 text-lg";

  return (
    <span
      data-testid="profile-avatar"
      className={`relative inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full ${sizeClass} ${theme.accentBg} ${theme.text}`}
    >
      <span aria-hidden="true">{name.slice(0, 1).toUpperCase()}</span>
      {image && (
        <img
          src={image}
          alt={t("account.profilePicture", { name })}
          className="absolute inset-0 h-full w-full object-cover"
          referrerPolicy="no-referrer"
          onError={(event) => {
            event.currentTarget.style.display = "none";
          }}
        />
      )}
    </span>
  );
}
